import PropTypes from 'prop-types';
import React from 'react';
import classes from './style.module.scss';

export default function FooterMenu({ footerMenus, baseUrl }) {
  const getValidUrl = (url) => {
    if (url.startsWith('/')) {
      return `${baseUrl}${url}`;
    }
    return url;
  };

  return (
    <div className={classes.container}>
      {footerMenus.map((footerMenuColumn, index) => (
        <div className={classes.column} key={index.toString()}>
          {footerMenuColumn.map(({ title, links }) => (
            <div key={title}>
              <div className={classes.title}>{title}</div>
              {links.map(({ text, url }) => (
                <a
                  key={text}
                  href={getValidUrl(url)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.item}
                >
                  {text}
                </a>
              ))}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

FooterMenu.propTypes = {
  footerMenus: PropTypes.arrayOf(PropTypes.any).isRequired,
  baseUrl: PropTypes.string.isRequired
};
